import { UserGroupIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Status } from "../../common/components/status";
import { classNames } from "../../common/utils/classnames";
import { GroupFragment } from "../../graphql/generated";

const GroupPic: React.FC<{ group?: GroupFragment; large?: boolean }> = ({
  group,
  large,
}) => {
  const status = React.useMemo(() => {
    return Status.for(group);
  }, [group]);

  return (
    <UserGroupIcon
      className={classNames(
        status.color.picClasses(),
        large ? "h-20 w-20" : "h-10 w-10",
        "rounded-full border-2"
      )}
    />
  );
};

export default GroupPic;
